import { useState } from 'react'
import { downloadCsv, Downloadloader } from './helper'
import { swlAlert } from './sweetAlert'
//import { orderCsvDownload } from '../distributorAdmin/api'
import { downloadClusterList, downloadClusterPincodeList, downloadCourier, downloadCourierMapping, downloadOfficeList, downloadPartner, downloadPickupLocation, downloadProductData, downloadRedemCatalugue, downloadUnmappedClusterPincode, downloadUserPincode } from '../company-module/api'
import { vendorDownloadList } from '../master/courier/api'


/**
 * DwonloadCsv component for downloading various CSV files based on type.
 * - Handles download requests for different data types (pincode, redemption, courier, vendor, product, etc.).
 * - Shows loader during download and displays alerts for errors or completion.
 * - Generates file names with type and timestamp, and triggers download using helper functions.
 */
const DwonloadCsv = ({ type, rowId = null, name = null, className = 'btn btn-primary btn-sm fw-semibold px-6 me-2' }) => {

    const [loader, setLoader] = useState(false)
    const downloadFile = async () => {
        setLoader(true);
        const currentDateTime = new Date().toISOString().replace(/[:.]/g, '-').replace('T', '_').slice(0, 19);
        const fileNameWithDateTime = `${type}${currentDateTime}.csv`;

        // Helper to handle download and error alert in a standard way
        const handleDownload = (promise) => {
            promise
                .then((response) => {
                    if (response.code === 0) {
                        swlAlert(response);
                    } else {
                        downloadCsv({
                            data: response,
                            fileName: fileNameWithDateTime,
                            fileType: 'text/csv',
                        });
                    }
                })
                .catch((error) => {
                    swlAlert({ code: 0, message: 'An error occurred while processing the download.' });
                    console.error('Download error:', error);
                })
                .finally(() => {
                    setLoader(false);
                });
        };

        // Add a short delay to show loader
        setTimeout(() => {
            switch (type) {
                case 'servisablePincode':
                    handleDownload(downloadUserPincode({ user_id: rowId }));
                    break;
                case 'redemption':
                    handleDownload(downloadRedemCatalugue({ redem_id: rowId }));
                    break;
                case 'courier_mapping_download':
                    handleDownload(downloadCourierMapping());
                    break;
                case 'courier_partner':
                    handleDownload(downloadPartner());
                    break;
                case 'courier_company':
                    handleDownload(downloadCourier());
                    break;
                case 'pickup':
                    handleDownload(downloadPickupLocation());
                    break;
                case 'vendor':
                    handleDownload(vendorDownloadList());
                    break;
                case 'business':
                case 'sub_business':
                case 'brand':
                case 'sub_categoryList':
                case 'categoryList':
                case 'product':
                case 'sku':
                    handleDownload(downloadProductData(type));
                    break;
                case 'office':
                    handleDownload(downloadOfficeList());
                    break;
                case 'cluster':
                    handleDownload(downloadClusterList());
                    break;
                case 'mapped-pincode':
                    handleDownload(downloadClusterPincodeList(rowId ? `cluster_id=${rowId}` : ''));
                    break;
                case 'unmapped-pincode':
                    handleDownload(downloadUnmappedClusterPincode());
                    break;
                default:
                    setLoader(false);
                    swlAlert({ code: 0, message: 'Invalid download type selected.' });
                    break;
            }
        }, 400);
    }

    return (
        <div className='d-flex align-items-center'>
            <button
                disabled={loader}
                type='button'
                onClick={downloadFile}
                className={className}
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='filter'

            >
                {loader ? <Downloadloader className='spinner-border spinner-border-md'></Downloadloader>
                    : <i class="bi fs-2 fw-semibold bi-download"></i>
                }
                {name}
            </button>
        </div>
    )
}

export { DwonloadCsv }
